<template>
    
    <div class="row" id="post-container">

        <div v-for="item in items" class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 mb-4 animate__animated animate__fadeIn">

            <div class="content-template extra-rounded flex-y" :style="{ backgroundImage: `url('/storage/${item.thumbnail}')` }">

                <div class="p-3 flex-y extra-rounded content-inner">

                    <div>
                        <h2 class="clip-text-2" style="color: white; text-shadow: 3px 3px #1d1800;">
                            <a style="color: white;" :href="`/${ item.type }/${ item.slug }`">{{ item.title }}</a>
                        </h2>
                        <div class="flex-x" style="align-content: center; justify-content: flex-start; align-items: flex-start;">
                            <div class="badge bg-warning">
                                <a :href="`/${ item.type }`" v-text="item.type"></a>
                            </div>
                            <p style="margin-left: 8px;" v-text="this.Timestamp(item.created_at)"></p>
                        </div>
                    </div>

                    <div>
                        <p class="clip-text-4 description">{{ item.description }}</p>
                    </div>

                    <div class="flex-x" style="justify-content: space-between; align-items: flex-end;">

                        <div style="display: flex;">
                            <img class="img-fluid rounded me-2" style="width: 48px; height: 48px;" :src="`https://cdn.discordapp.com/avatars/${ item.user.id }/${ item.user.avatar }.webp`" alt="Profile Picture">
                            <div style="display: flex; flex-direction: column; justify-content: center;">
                                <p>
                                    <a :href="`/profile/${ item.user.slug }`">By {{ item.user.username }}</a>
                                </p>
                            </div>
                        </div>

                        <button type="button" class="btn btn-warning">
                            <a :href="`/${ item.type }/${ item.slug }`">
                                <span style="color: black;" v-show="item.type == 'podcast'">Listen Now</span>
                                <span style="color: black;" v-show="item.type == 'blog'">Read More</span>
                            </a>
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <div v-if="this.items.length >= 9" class="flex-x" style="justify-content: center">
        <button v-show="this.request == false" type="button" class="btn btn-warning load-more-posts-button" v-bind="this.count" @click="this.GetMorePosts()">
            Load More
        </button>
        <i v-show="this.request == true" id="loading-spinner" class="fa-2x fas fa-spinner fa-spin"></i>
    </div>

</template>

<script>

import moment from 'moment';

export default {

    data () {
        return {
            count: 0,
            offset: 0,
            request: false
        }
    },

    props: ['items', 'type'],

    created () {
        this.count = this.items.length;
    },

    methods: {
        Timestamp (date) {
            return moment(date).format('MMMM Do YYYY, hh:mm a');
        },

        async GetMorePosts () {
            this.request = true;
            this.offset += 11;
            const response = await axios.post(`/loadposts`, { offset: this.offset, type: this.type });

            JSON.parse(response.data.posts).forEach(e => {
                this.items.push(e);
            });

            this.request = false;
        }
    }

}
</script>